import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Document, Organization } from '../../../shared/sdk';
import { DocumentService } from '../../document.service';

@Component({
  selector: '[app-active-document]',
  templateUrl: './active-document.component.html',
  styleUrls: ['./active-document.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveDocumentComponent implements OnInit {
  @Input() activeOrg: Organization;
  @Input() checked: boolean;
  @Input() currentLang: string;
  @Input() document: Document;
  @Input() incoming: boolean;
  @Input() isChecked: boolean;
  @Output() addPayment = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() check = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() toggleSelected = new EventEmitter();

  constructor(private documentService: DocumentService) {}

  get isPast(): boolean {
    return this.documentService.isPast(this.document);
  }

  ngOnInit(): void {}

  onAddPayment(): void {
    this.addPayment.emit(this.document);
  }

  onCancel(): void {
    this.cancel.emit(this.document);
  }

  onDelete(): void {
    this.delete.emit(this.document);
  }

  onToggleSelected(): void {
    this.check.emit(this.document);
  }

  get remainingDue(): number {
    return this.documentService.getRemainingDue(this.document);
  }
}
